import { render, staticRenderFns } from "./ModalWelcomeFeature.vue?vue&type=template&id=dd148d8c"
import script from "./ModalWelcomeFeature.vue?vue&type=script&lang=ts"
export * from "./ModalWelcomeFeature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports